export const verification = {
    title: 'Xác thực danh tính',
    infomation: 'Thông tin cá nhân.',
    content:
        'Vui lòng đảm bảo rằng tất cả thông tin đã nhập phải đồng nhất với giấy tờ tùy thân của bạn. Bạn không thể thay đổi thông tin sau khi đã nhấn xác nhận.',
    selectInfo: 'Chọn loại giấy tờ tùy thân.',
    passport: 'Hộ chiếu',
    identity: 'Thẻ căn cước công dân',
    countries: 'Chọn quốc gia',
    numberCmt: 'Số căn cước công dân',
    numberPassport: 'Số hộ chiếu',
    identityTitle: 'Ảnh thẻ căn cước.',
    passportTitle: 'Ảnh thẻ hộ chiếu.',
    line1: 'Vui lòng đảm bảo rằng ảnh chụp giấy tờ tùy thân phải rõ ràng và đầy đủ chi tiết.',
    line2: 'Vui lòng sử dụng hình ảnh có kích thước tối đa 10MB',
    line3: 'Vui lòng sử dụng hình ảnh có định dạng là JPG, JPEG, PNG.',
    label1: 'Đủ chi tiết.',
    label2: 'Không được thiếu',
    label3: 'Không bị mờ',
    label4: 'Không bị bóng',
    contentBefore: 'Tải lên mặt trước',
    contentAfter: 'Tải lên mặt sau',
    imageBefore: 'Mặt trước',
    imageAfter: 'Mặt sau',
    passportLabel: 'Ảnh hộ chiếu',
    portraitLabel: 'Ảnh chân dung',
    back: 'Quay lại',
    nextStep: 'Tiếp tục',
    portraitTitle: 'Ảnh chân dung tự chụp.',
    portraitContent1:
        'Vui lòng không đội mũ, đeo kính hoặc sử dụng bộ lọc, đủ ánh sáng. ',
    portraitContent2: 'Vui lòng sử dụng hình ảnh có kích thước tối đa 10MB. ',
    portraitContent3: 'Vui lòng sử dụng hình ảnh có định dạng là JPG, JPEG, PNG.',
    portraitContent4Cccd:
        'Chụp ảnh rõ khuôn mặt của bạn đang cầm căn cước công dân và một tờ giấy viết ngày tháng chụp và ghi "ste.sbgroup.finance".',
    portraitContent4Passport:
        'Chụp ảnh rõ khuôn mặt của bạn đang cầm hộ chiếu và một tờ giấy viết ngày tháng chụp và ghi "ste.sbgroup.finance".',
    contentPortrait: 'Tải ảnh lên',
    completeTitle: 'Cảm ơn đã giúp chúng tôi xác thực danh tính!',
    completeContent: 'Vui lòng đợi Admin duyệt xác minh trước khi mua hàng',
    gotoHome: 'Đến trang chủ',
    requiredImage: 'không được để trống',
    required: {
        passportLabel: 'Ảnh hộ chiếu không được để trống',
        portraitLabel: 'Ảnh chân dung không được để trống',
        imageBefore: 'Mặt trước không được để trống',
        imageAfter: 'Mặt sau không được để trống',
    },
    validateMaxSizeImage: 'Chỉ được upload file dưới 10MB',
    validateMinSizeImage: 'Ảnh phải có kích thước tối thiểu 10kb',
    validateImage: 'Chỉ được tải lên ảnh dạng ảnh jpg,png.jpeg',
    placeholderCmt: 'Ví dụ: B2412111',
};
